// Methods
const scroll = function(pos = { x: 0, y: 0 }) {
  document.documentElement.scrollTo && document.documentElement.scrollTo(pos.x, pos.y)
  window.scrollTo && window.scrollTo(pos.x, pos.y)
}

// 全屏
const fullScreen = function() {
  var docElm = document.documentElement
  if (docElm.requestFullscreen) {
    // W3C
    docElm.requestFullscreen()
  } else if (docElm.mozRequestFullScreen) {
    // FireFox
    docElm.mozRequestFullScreen()
  } else if (docElm.webkitRequestFullScreen) {
    // Chrome等
    docElm.webkitRequestFullScreen()
  } else if (docElm.msRequestFullscreen) {
    // IE11
    docElm.msRequestFullscreen()
  }
}

// 退出全屏
const exitFullScreen = function() {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

// 图片转换为Base64
const getImgToBase64 = function(url, callback) {
  var img = new Image()
  img.setAttribute('crossOrigin', 'Anonymous')
  img.onload = function() {
    var canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    callback(canvas.toDataURL('image/png'))
    canvas = null
  }
  img.src = url
}

// 将base64转为文件
const dataURLtoFile = function(dataurl, filename) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export {
  scroll,
  fullScreen,
  exitFullScreen,
  getImgToBase64,
  dataURLtoFile
}



// WEBPACK FOOTER //
// ./src/commons/utils/Methods.js